<script lang="ts">
  import type { OutputLine } from './output-lines';

  interface Props {
    lines: OutputLine[];
    side?: 'expected' | 'actual' | 'plain';
    showWhitespace?: boolean;
    label: string;
  }

  let { lines, side = 'plain', showWhitespace = false, label }: Props = $props();
  const changedClass = $derived(
    side === 'expected' ? 'diff-ins' : side === 'actual' ? 'diff-del' : '',
  );
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<!-- prettier-ignore -->
<pre class="output" tabindex="0" aria-label={label}>{#if lines.length === 0}<span class="empty">（空）</span>{/if}{#each lines as line, i (i)}<span class={line.changed ? changedClass : undefined}>{line.text}{#if showWhitespace}{#each { length: line.trailing }, j (j)}<span class="ws" aria-label="空白"></span>{/each}{#if line.eol}<span class="eol" aria-label="改行"></span>{/if}{:else}{' '.repeat(line.trailing)}{/if}</span>{i < lines.length - 1 ? '\n' : ''}{/each}</pre>

<style>
  .output {
    min-height: 2.5em;
  }
  .empty {
    color: var(--text-soft);
  }
</style>
